( function () {
	'use strict';

	// Usage: <loading data-message="Fetching data ..." inline="true"></loading>
	//
	// inline ( true ) for inline loading
	// inline ( false ) for content loading
	// Creates:
	//
	function loading () {
		var directiveData = {
			'restrict'    : 'E',
			'templateUrl' : '/templates/components/loading/loading.html',
			'scope'       : {
				'message' : '@',
				'inline'  : '=',

				'defaultBtn'  : '=',
				'hideSpinner' : '='
			}
		};

		return directiveData;
	}

	angular
		.module( 'app.components' )
		.directive( 'loading', loading );
} )();
